import { Injectable } from '@angular/core';
import { HttpHelperService } from './http-helper.service';

import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';


export interface RefreshRequestBody {
  reportUUID: string;
}


export interface RefreshStatusWaitBody {
  reportUUID: string;
  waitSeconds?: number;
}


export interface RefreshStartResponse {
  success: boolean;
}


export interface RefreshStatusItem {
  groupId: string;
  datasetId: string;
  status: string;
  startTime: string;
  endTime: string;
  error?: string | null;
}


export interface RefreshStatusResponse {
  isComplete: boolean;
  refreshStatus: RefreshStatusItem[];
  reportUUID: string;
}

@Injectable({
  providedIn: 'root',
})
export class CoreService {
  private baseUrl = environment.endpoint + '/core';

  constructor(
    private http: HttpClient,
    private httpHelperService: HttpHelperService,
  ) { }

  async getNavigation() {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/navigation`,
      );
      if (result && result.response) {
        resolve(result.response.items);
      } else {
        reject('API ERROR');
      }
    });
  }

  async getReportsData(reports: { reportId: string; groupId: string; }[]) {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/data`,
        { reports },
      );
      if (result && result.response) {
        resolve(result.response);
      } else {
        reject('API ERROR');
      }
    });
  }

  async getGroups() {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'GET',
        `${this.baseUrl}/groups`,

      );
      if (result && result.response) {
        resolve(result.response);
      } else {
        reject('API ERROR');
      }
    });
  }

  async createUpdateGroup(newGroup: { code: string; name: string; }) {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/group`, { ...newGroup }
      );
      if (result && result.response) {
        resolve(result.response);
      } else {
        reject('API ERROR');
      }
    });
  }

  async deleteGroup(code: string) {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'DELETE',
        `${this.baseUrl}/group/${code}`
      );
      if (result && result.response) {
        resolve(result.response);
      } else {
        reject('API ERROR');
      }
    });
  }


  async startRefresh(reportUUID: string): Promise<RefreshStartResponse> {
    return new Promise<RefreshStartResponse>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/refresh`,
        { reportUUID },
      );
      if (result && result.response) {
        resolve(result.response);
      } else {
        reject('API ERROR');
      }
    });
  }

  async getRefreshStatus(reportUUID: string): Promise<RefreshStatusResponse> {
    return new Promise<RefreshStatusResponse>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/refresh/status`,
        { reportUUID },
      );
      if (result && result.response) {
        resolve(result.response);
      } else {
        reject('API ERROR');
      }
    });
  }

  async waitForRefreshStatus(reportUUID: string, waitSeconds?: number): Promise<RefreshStatusResponse> {
    const body: RefreshStatusWaitBody = { reportUUID };
    if (waitSeconds !== undefined) {
      body.waitSeconds = Math.max(10, Math.min(120, waitSeconds));
    }
    return new Promise<RefreshStatusResponse>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/refresh/status/wait`,
        body,
      );
      if (result && result.response) {
        resolve(result.response);
      } else {
        reject('API ERROR');
      }
    });
  }

}
